import getShopInfoByLink from '@services/shops/getShopInfoByLink';

import fetchShop from './fetchShop';

const fetchShopByLink = ({ shopLink }) =>
  fetchShop({
    run: axios => getShopInfoByLink({ axios, shopLink }),
  });

export default fetchShopByLink;
